import { AlarmSeverity } from '@/types';

/** Tailwind-native severity tokens — see statusStyles.ts for why severityColor.ts (MUI-Theme-dependent) is kept separately for not-yet-migrated consumers (e.g. features/notifications/NotificationRow.tsx). */
export const SEVERITY_LABEL: Record<AlarmSeverity, string> = {
  crit: 'Critical',
  warn: 'Warning',
  info: 'Info',
};

export const SEVERITY_TEXT_CLASS: Record<AlarmSeverity, string> = {
  crit: 'text-error',
  warn: 'text-warning',
  info: 'text-info',
};

export const SEVERITY_SOFT_BG_CLASS: Record<AlarmSeverity, string> = {
  crit: 'bg-error-light',
  warn: 'bg-warning-light',
  info: 'bg-info-light',
};

/** Solid color bar used as the left "stripe" accent on an alarm row. */
export const SEVERITY_STRIPE_CLASS: Record<AlarmSeverity, string> = {
  crit: 'bg-error',
  warn: 'bg-warning',
  info: 'bg-info',
};
